import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { IEditService, IListService } from '@app/services';
import { SavedReportFilterModel } from '../models/saved-report-fiter.model';

@Injectable()
export class SavedReportFilterService implements IListService, IEditService<SavedReportFilterModel> {
	endpointBase = '/api/saved-report-filter';

	constructor(private readonly http: HttpClient) {}

	getList(): Observable<any> {
		return EMPTY;
	}

	public getById(id: number): Observable<any> {
		return this.http.get(`${this.endpointBase}/${id}`);
	}

	public getSavedReportFilters(reportType: number): Observable<any> {
		return this.http.get(`${this.endpointBase}`, {
			params: {
				reportType,
			},
		});
	}

	public createEntity(model: SavedReportFilterModel): Observable<any> {
		return this.http.post<any>(`${this.endpointBase}`, model);
	}

	public deleteEntity(id: number): Observable<any> {
		return this.http.delete(`${this.endpointBase}/${id}`);
	}

	public updateEntity(model: SavedReportFilterModel): Observable<any> {
		return this.http.put(`${this.endpointBase}/${model.Id}`, {
			model,
		});
	}
}
